module.exports = __webpack_public_path__ + "static/img/exhibition_h.6bc8df8b.png";